import React, { useState } from "react";
import { MyDataTable } from "../partials/data-tables/data-table-catalog.tsx";
import MainTabs from "../partials/main-tabs";
import FormModal from "../partials/form-modals/catalog/new-form.jsx";

const Home = () => {
	const [isModalOpen, setModalOpen] = useState(false);

	const handleSubmit = (data) => {
		alert(`Submitted: ${JSON.stringify(data)}`);
	};

	// const readFolderContents = async (folderPath) => {
	// 	try {
	// 		const contents = await RNFS.readDir(folderPath);
	// 		console.log("Folder contents:", contents);
	// 		return contents; // Returns an array of file and directory objects
	// 	} catch (error) {
	// 		console.error("Error reading folder:", error);
	// 		throw error;
	// 	}
	// };

	// // Example usage:
	// const folderPath = "file://Users/robmartinez/Documents/Image-Line/FL Studio/Projects"; // Or any other path you want to read
	// readFolderContents(folderPath)
	// 	.then((contents) => {
	// 		contents.forEach((item) => {
	// 			console.log(item.name, item.isFile() ? "File" : "Directory");
	// 		});
	// 	})
	// 	.catch((error) => {
	// 		// Handle error
	// 	});

	return (
		<div>
			<div class="main-tabs">
				<div class="mx-auto">
					<MainTabs tabIndexSelected={0} />
					<div id="myTabContent">
						<div class="flex justify-between w-full page-header">
							<div class="page-heading">
								<img src="../../../assets/icons/music-room-icon.png" alt="Fans" class="icon" />
								<h2 class="text-4xl font-bold dark:text-white">
									<span class="text-transparent bg-clip-text bg-gradient-to-r to-yellow-500 from-amber-700">MUSIC ROOM</span>
								</h2>
							</div>
							<div>
								<button
									onClick={() => setModalOpen(true)}
									type="button"
									class="border text-slate-400 hover:text-yellow-500 border-slate-600 focus:outline-none focus:ring-2 focus:text-amber-700 focus:ring-amber-700 font-medium rounded-lg text-sm px-4 py-2 me-2 mb-2">
									New Song
								</button>
							</div>
						</div>
						<div class="shadow-xl bg-slate-500 p-4 rounded-lg tabpanel" id="profile" role="tabpanel" aria-labelledby="profile-tab">
							<MyDataTable onOpenForm={setModalOpen} />
						</div>
					</div>
				</div>
				<script src="https://unpkg.com/@themesberg/flowbite@1.2.0/dist/flowbite.bundle.js"></script>
				{/* <div className="text-2xl font-bold pt-14">
					Hello {currentUser.displayName ? currentUser.displayName : currentUser.email}, you are now logged in.
				</div> */}
			</div>
			<div className=" flex items-center justify-center">
				<FormModal isOpen={isModalOpen} onClose={() => setModalOpen(false)} onSubmit={handleSubmit} />
			</div>
		</div>
	);
};

export default Home;
